module.exports = __webpack_public_path__ + "media/src/images/toushikun-4b08784e321d797c1854ba6e729cc9c7.png";